import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import { Stack } from '@famly/mf_layout_stack';
import { Spinner } from '@famly/mf_feedback_spinner';
/**
 * Shown in place of the children list while it is being fetched.
 */
export const KinderConnectCaptureSettingsChildrenListLoading = () => (_jsx(Stack, { justifyContent: "center", marginY: 6, children: _jsx(Spinner, { size: 32, "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) }));
